import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { KeysGetter } from "protico-encryption/dist/KeyPair";
import { TypedThunk } from "..";
import { KeypairState } from "../../types/types";
import EncryptUtils from "../../utils/encryption.utils";
import { loadState, saveState } from "../../utils/localStorage.utils";
import { LocalStorageKeys } from "../../utils/strings.utils";
interface LocalKeys {
  [address: string]: string;
}
interface TSignup {
  currentAddress: string;
  keysGetter: KeysGetter;
}
interface TSetEncryptedPrivateKey {
  currentAddress: string;
  encryptedPrivateKey: string | undefined;
}
export interface KeyStorageState {
  pin?: string;
  privateKey?: string;
  encryptedPrivateKey?: string;
  loaded: boolean;
  keypairState: KeypairState;
}

const initialState = {
  loaded: false,
  keypairState: KeypairState.PENDING,
} as KeyStorageState;

const keysSlice = createSlice({
  name: "keys",
  initialState,
  reducers: {
    setKeypairState: (state, action: PayloadAction<KeypairState>) => {
      console.log("setKeypairState action called");
      state.keypairState = action.payload;
    },
    setPin: (state, action: PayloadAction<string | undefined>) => {
      state.pin = action.payload;
    },
    signUp: (state, action: PayloadAction<TSignup>) => {
      // const privateKey = KeyPair.fromUint8Array(action.payload.private!);
      const keysGetter = action.payload.keysGetter;
      const privateKey = Buffer.from(keysGetter.private!).toString("base64");
      state.privateKey = privateKey;
      const encryptedPrivateKey = EncryptUtils.encrypt(privateKey, state.pin!);
      setEncryptedPrivateKey({
        currentAddress: action.payload.currentAddress,
        encryptedPrivateKey,
      });
    },
    signIn: (state, action: PayloadAction<string>) => {
      // try {
      const decrypt = EncryptUtils.decrypt(
        state.encryptedPrivateKey!,
        action.payload
      );
      if (decrypt.startsWith("MH")) {
        state.privateKey = decrypt;
        state.pin = action.payload;
      } else {
        throw new Error("Invalid pin");
      }
      // } catch (e) {
      // TODO : Show login error
      // console.log("fail", e);
      // }
    },
    setEncryptedPrivateKey: (
      state,
      action: PayloadAction<TSetEncryptedPrivateKey>
    ) => {
      const privateKeyStore = loadState(LocalStorageKeys.PRIVATE_KEY) ?? {};
      let userPrivateKey: LocalKeys = {};
      userPrivateKey[action.payload.currentAddress] =
        action.payload.encryptedPrivateKey;
      saveState(LocalStorageKeys.PRIVATE_KEY, {
        ...privateKeyStore,
        ...userPrivateKey,
      });
      state.encryptedPrivateKey = action.payload.encryptedPrivateKey;
    },
    setLoaded: (state, action: PayloadAction<boolean>) => {
      state.loaded = action.payload;
    },
  },
});

export const {
  setPin,
  signUp,
  setLoaded,
  setEncryptedPrivateKey,
  signIn,
  setKeypairState,
} = keysSlice.actions;
export default keysSlice.reducer;

// /************************************************************* */
// /* Async Action items	   									*/
// /************************************************************* */

export const getLocalStorageKeysInfo =
  (currentAddress: string): TypedThunk =>
  async (dispatch) => {
    // TODO: set pin localStorage
    const privateKeyStore = loadState(LocalStorageKeys.PRIVATE_KEY);
    if (privateKeyStore)
      dispatch(
        setEncryptedPrivateKey({
          currentAddress,
          encryptedPrivateKey: privateKeyStore[currentAddress],
        })
      );
    dispatch(setLoaded(true));
  };
